import React, { useEffect, useRef, useState } from "react"
import Esign from "../Esign";
import { useParams } from "react-router-dom";
import useToggle from "../../../../hooks/toggle";
import { selecteddocumentesign } from "../ReviewDocs";
import { ALAaddendumtopurchasePOST, getexternaldocuments, getSavedOfferDetails } from "../../../../api/transaction";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from 'react-to-print';
import { CSpinner } from "@coreui/react";
import { notification_success } from "../../../../state/actions";
import { toast } from "react-toastify";
const ALAaddendumtopurchase = ()=>{
  const {id,user} : any = useParams()
  const componentRef = useRef();
  const [clause,setClause] = useState({
      offer_id :id,
      buyer :"",
      seller :"",
      property_located_address :"",
      property_agreement_date :null,
      appraised_value :"",
      buyer1_signature :"",
      buyer1_signature_date :null,
      buyer2_signature :"",
      buyer2_signature_date :null,
      seller1_signature :"",
      seller1_signature_date :null,
      seller2_signature :"",
      seller2_signature_date :null,
      agent1_signature :"",
      agent1_signature_date :null,
      agent2_signature :"",
      agent2_signature_date :null
  })
  const [canvasmodal, setCanvasModal] = useToggle(false);
  const [htmlContent, setHtmlContent] = useState("");
  const [offerdetails, setOfferDetails]:any = useState({});
  const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
      offerid : "",
    document_name: "",
    image_base64: "",
    sign_role: 1
    })

    const printf = () => {
      // window.print()
      handlePrint()
};  
const dispatch = useDispatch()
 // @ts-ignore
 const val = useSelector((state) => state?.new?.signset)
const [loader,setloading] = useState(false)


useEffect(()=>{
  if(val){
    if(user == "seller"){
      setClause({ ...clause, seller1_signature: val })
    }
    if(user == "client"){
      setClause({ ...clause, buyer1_signature: val })
    }
  }
  },[val])

const send = async()=>{
setloading(true)
if(val){

  if(user==="seller"){

         if(clause?.seller1_signature){
            let res =  await ALAaddendumtopurchasePOST(clause)
         
            if(res?.status == "success"){
              alert("Submitted Successfully")
          }
          else{
              alert("Something went wrong")
          }
         }
     }
     else if(user==="client"){
     
         if(clause?.buyer1_signature){
           let res =   await ALAaddendumtopurchasePOST(clause)
      
           if(res?.status == "success"){
            alert("Submitted Successfully")
        }
        else{
            alert("Something went wrong")
        }
         }
     }
}
else{
   await ALAaddendumtopurchasePOST(clause)
}

  setloading(false)
}


useEffect(()=>{
(async function () {
  let offerdetails = await getSavedOfferDetails(id)
  
    setOfferDetails(offerdetails[0])
  let res = await getexternaldocuments(id,"addendumpurchase")
 
try {
  setClause({...clause,
    buyer :res?.data.buyer,
    seller :res?.data.seller,
      property_located_address :res?.data.property_located_address,
      property_agreement_date :res?.data.property_agreement_date,
      appraised_value :res?.data.appraised_value,
      buyer1_signature :res?.data.buyer1_signature,
      buyer1_signature_date :res?.data.buyer1_signature_date,
      buyer2_signature :res?.data.buyer2_signature,
      buyer2_signature_date :res?.data.buyer2_signature_date,
      seller1_signature :res?.data.seller1_signature,
      seller1_signature_date :res?.data.seller1_signature_date,
      seller2_signature :res?.data.seller2_signature,
      seller2_signature_date :res?.data.seller2_signature_date,
      agent1_signature :res?.data.agent1_signature,
      agent1_signature_date :res?.data.agent1_signature_date,
      agent2_signature :res?.data.agent2_signature,
      agent2_signature_date :res?.data.agent2_signature_date
  })
} catch (error) {
  console.log(error);
}
 
})()
},[])

const handlePrint = useReactToPrint({
  content: () => componentRef.current,
});



  return(
      <>
      <table style={{width: "1100px", margin: "0 auto", background: "#fff", padding: "20px"}} ref={componentRef}>
<tbody>
  <tr>
    <td>
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td style={{ width: "30%" }}>
              <img
                style={{ width: 250 }}
                src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
              />
            </td>
            <td style={{ width: "40%", textAlign: "center" }}>
              <span style={{ fontSize: 20, fontWeight: 600 }}>
                ADDENDUM TO PURCHASE AGREEMENT
              </span>
              <br />
              <span style={{ fontSize: 15 }}>
                FHA Amendatory Clause and Real Estate Certification{" "}
              </span>
              <br />
              <span style={{ fontSize: 11 }}>
                This addendum is legally binding. If not understood, seek
                legal advice.)
              </span>
            </td>
            <td
              style={{
                width: "30%",
                float: "right",
                verticalAlign: "middle"
              }}
            >
              <img
                style={{ width: 40, marginRight: 15 }}
                src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg"
                alt=""
              />
              <img
                style={{ width: 50 }}
                src="https://storagemilforddev.blob.core.windows.net/images/eh.svg"
                alt=""
              />
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
  <tr>
    <td style={{ paddingTop: 30 }}>
      <span>
        This Addendum shall be an Integral part of the Purchase Agreement
        described below. Buyer and Seller agree that the Purchase Agreement Is
        expressly conditioned upon the terms of this addendum. To the extent
        that this modifies the Purchase Agreement, this Agreement controls.{" "}
      </span>
    </td>
  </tr>
  <tr>
    <td style={{ paddingTop: 10 }}>
      <span>
        Buyer(s):{" "}
        <input
          type="text"
          value={offerdetails?.leadName}
          // onChange={(e)=>setClause({...clause,buyer:e.target.value})}
          style={{
            outline: "none",
            border: "none",
            borderBottom: "1px solid black",
            width: "90%"
          }}
        />
      </span>
    </td>
  </tr>
  <tr>
    <td style={{ paddingTop: 10 }}>
      <span>
        Seller(s):{" "}
        <input
          type="text"
          value={clause?.seller}
          onChange={(e)=>setClause({...clause,seller:e.target.value})}
          style={{
            outline: "none",
            border: "none",
            borderBottom: "1px solid black",
            width: "90%"
          }}
        />
      </span>
    </td>
  </tr>
  <tr>
    <td style={{ paddingTop: 10 }}>
      <span>
        Property Located at:{" "}
        <input
          type="text"//@ts-ignore
          value={offerdetails?.propertyAddress}
          // onChange={(e)=>setClause({...clause,property_located_address:e.target.value})}
          style={{
            outline: "none",
            border: "none",
            borderBottom: "1px solid black",
            width: "80%"
          }}
        />
      </span>
    </td>
  </tr>
  <tr>
    <td style={{ paddingTop: 10 }}>
      <span>
        Purchase Agreement Dated: <input type="date" 
          value={clause?.property_agreement_date}
          onChange={(e)=>setClause({...clause,property_agreement_date:e.target.value})}
        />
      </span>
    </td>
  </tr>
  <tr>
    <td style={{ borderBottom: "3px solid black", paddingTop: 10 }}></td>
  </tr>
  <tr>
    <td style={{ textAlign: "center" }}>
      <span style={{ fontWeight: 600 }}>
        Federal Housing Administration (FHA) Amendatory Clause [4155.1 REV-4
        (6/92)
      </span>
    </td>
  </tr>
  <tr>
    <td style={{ paddingTop: 10 }}>
      <span>
        It is expressly agreed that notwithstanding any other provisions of
        this contract, the purchaser shall NOT be obligated to complete the
        purchase of the property described herein or to incur any penalty by
        forfeiture of earnest money deposits or otherwise unless the purchaser
        has been given in accordance with HUD/FHA or VA requirements a written
        statement by the Federal Housing Commission, Veterans Administration,
      </span>
    </td>
  </tr>
  <tr>
    <td style={{ paddingTop: 10 }}>
      <span>
        or a Direct Endorsement lender setting forth the appraised value of
        the property of not less than: ${" "}
        <input
          type="text"
          value={clause?.appraised_value}
          onChange={(e)=>setClause({...clause,appraised_value:e.target.value})}
          style={{
            outline: "none",
            border: "none",
            borderBottom: "1px solid black",
            width: 100
          }}
        />
        The purchaser shall have the privilege and option of proceeding with
        the consummation of the contract without regard to the amount of the
        appraised valuation. The appraised valuation is arrived at to
        determine the maximum mortgage the Department of Housing and Urban
        Development will insure. HUD does not warrant the value nor condition
        of the property. The purchaser should satisfy himself/herself that the
        price and condition of the property are acceptable.
      </span>
    </td>
  </tr>
  <tr>
    <td style={{ paddingTop: 10 }}>
      <span>
        The dollar amount inserted in the amendatory clause is the sales price
        as stated in the contract. If the borrower and seller agree to adjust
        the sales price in response to an appraised value that is less than
        the sales price, a new amendatory clause is NOT required. However, the
        loan application package must include the original sales contract with
        the same price shown on the amendatory clause, along with the revised
        or amended sales contract.{" "}
      </span>
    </td>
  </tr>
  <tr>
    <td style={{ paddingTop: 10 }}>
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td>
            <span style={{paddingRight: ".5rem"}}>Buyer</span>
              <span>
                <img
                  src={user === "client" ? (val || clause?.buyer1_signature) : clause?.buyer1_signature}
                  width={'100px'}
                  style={{
                    outline: "none",
                    border: "none",
                    borderBottom: "1px solid black",
      
                  }}
                />
              </span>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "100%" }}>
                      
                    </td>
                    <td>
                      <input type="date" 
                        value={clause?.buyer1_signature_date ? clause?.buyer1_signature_date  : (user === "client" && val || clause?.buyer1_signature) ? new Date().toISOString().split('T')[0] : ""}
                        onChange={(e)=>setClause({...clause,buyer1_signature_date:e.target.value})}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <span>
              <span style={{paddingRight: ".5rem"}}> seller</span>
                <img
               src={user === "seller" ? (val || clause?.seller1_signature) : clause?.seller1_signature}
               width={'100px'}
                  style={{
                    outline: "none",
                    border: "none",
                    borderBottom: "1px solid black",
            
                  }}
                />
              </span>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "100%" }}>
                      
                    </td>
                    <td>
                      <input type="date" 
                       value={clause?.seller1_signature_date  ? clause?.seller1_signature_date  : (user === "seller" && val || clause?.seller1_signature) ? new Date().toISOString().split('T')[0] : ""}
                       onChange={(e)=>setClause({...clause,seller1_signature_date:e.target.value})}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
  <tr>
    <td style={{ paddingTop: 10 }}>
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td>
              <span>
                <input
                  type="text"
                  value={clause?.buyer2_signature}
                  onChange={(e)=>setClause({...clause,buyer2_signature:e.target.value})}
                  style={{
                    outline: "none",
                    border: "none",
                    borderBottom: "1px solid black",
                    width: "99%"
                  }}
                />
              </span>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "100%" }}>
                      <span>Buyer</span>
                    </td>
                    <td>
                      <input type="date" 
                       value={clause?.buyer2_signature_date}
                       onChange={(e)=>setClause({...clause,buyer2_signature_date:e.target.value})}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <span>
                <input
                  type="text"
                  value={clause?.seller2_signature}
                  onChange={(e)=>setClause({...clause,seller2_signature:e.target.value})}

                  style={{
                    outline: "none",
                    border: "none",
                    borderBottom: "1px solid black",
                    width: "99%"
                  }}
                />
              </span>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "100%" }}>
                      <span> seller</span>
                    </td>
                    <td>
                      <input type="date" 
                      value={clause?.seller2_signature_date}
                      onChange={(e)=>setClause({...clause,seller2_signature_date:e.target.value})}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
  <tr>
    <td style={{ paddingTop: 10 }}>
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td>
              <span>
                <input
                  type="text"
                  value={clause?.agent1_signature}
                      onChange={(e)=>setClause({...clause,agent1_signature:e.target.value})}
                  style={{
                    outline: "none",
                    border: "none",
                    borderBottom: "1px solid black",
                    width: "99%"
                  }}
                />
              </span>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "100%" }}>
                      <span>Agent</span>
                    </td>
                    <td>
                      <input type="date" 
                      value={clause?.agent1_signature_date}
                      onChange={(e)=>setClause({...clause,agent1_signature_date:e.target.value})}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <span>
                <input
                  type="text"
                  value={clause?.agent2_signature}
                  onChange={(e)=>setClause({...clause,agent2_signature:e.target.value})}
                  style={{
                    outline: "none",
                    border: "none",
                    borderBottom: "1px solid black",
                    width: "99%"
                  }}
                />
              </span>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "100%" }}>
                      <span> Agent</span>
                    </td>
                    <td>
                      <input type="date" 
                       value={clause?.agent2_signature_date}
                       onChange={(e)=>setClause({...clause,agent2_signature_date:e.target.value})}/>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
  <tr>
    <td style={{ textAlign: "center", paddingTop: 10 }}>
      <span style={{ fontWeight: 600 }}>REAL ESTATE CERTIFICATION</span>
    </td>
  </tr>
  <tr>
    <td>
      <span>
        We, the undersigned, Seller(s), Buyer(s), and Agent(s), involved in
        the transaction, each certify that the terms of the Agreement are true
        to our best knowledge and belief and that any other Agreement entered
        into by any of these parties in connection with this transaction is
        attached to this sales agreement.{" "}
      </span>
    </td>
  </tr>
  <tr>
    <td style={{ paddingTop: 10 }}>
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td>
            <span style={{paddingRight: ".5rem"}}>Buyer</span>
              <span>
                <img
                  src={user === "client" ? (val || clause?.buyer1_signature) : clause?.buyer1_signature}
                  style={{
                    outline: "none",
                    border: "none",
                    borderBottom: "1px solid black",
                    width: "100px"
                  }}
                />
              </span>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "100%" }}>
                      
                    </td>
                    <td>
                      <input type="date" 
                         value={clause?.buyer1_signature_date ? clause?.buyer1_signature_date  : (user === "client" && val || clause?.buyer1_signature) ? new Date().toISOString().split('T')[0] : ""}
                         onChange={(e)=>setClause({...clause,buyer1_signature_date:e.target.value})}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
            <span style={{paddingRight: ".5rem"}}> seller</span>
              <span>
                <img
                  src={user === "seller" ? (val || clause?.seller1_signature) : clause?.seller1_signature}

                  style={{
                    outline: "none",
                    border: "none",
                    borderBottom: "1px solid black",
                    width: "100px"
                  }}
                />
              </span>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "100%" }}>
                      
                    </td>
                    <td>
                      <input type="date" 
                       value={clause?.seller1_signature_date ? clause?.seller1_signature_date  : (user === "seller" && val || clause?.seller1_signature) ? new Date().toISOString().split('T')[0] : ""}
                       onChange={(e)=>setClause({...clause,seller1_signature_date:e.target.value})}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
  <tr>
    <td style={{ paddingTop: 10 }}>
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td>
              <span>
                <input
                  type="text"
                  value={clause?.buyer2_signature}
                  onChange={(e)=>setClause({...clause,buyer2_signature:e.target.value})}
                  style={{
                    outline: "none",
                    border: "none",
                    borderBottom: "1px solid black",
                    width: "99%"
                  }}
                />
              </span>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "100%" }}>
                      <span>Buyer</span>
                    </td>
                    <td>
                      <input type="date" 
                        value={clause?.buyer2_signature_date}
                        onChange={(e)=>setClause({...clause,buyer2_signature_date:e.target.value})}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <span>
                <input
                  type="text"
                  value={clause?.seller2_signature}
                  onChange={(e)=>setClause({...clause,seller2_signature:e.target.value})}
                  style={{
                    outline: "none",
                    border: "none",
                    borderBottom: "1px solid black",
                    width: "99%"
                  }}
                />
              </span>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "100%" }}>
                      <span> seller</span>
                    </td>
                    <td>
                      <input type="date" 
                       value={clause?.seller2_signature_date}
                       onChange={(e)=>setClause({...clause,seller2_signature_date:e.target.value})}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
  <tr>
    <td style={{ paddingTop: 10 }}>
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td>
              <span>
                <input
                  type="text"
                  value={clause?.agent1_signature}
                  onChange={(e)=>setClause({...clause,agent1_signature:e.target.value})}
                  style={{
                    outline: "none",
                    border: "none",
                    borderBottom: "1px solid black",
                    width: "99%"
                  }}
                />
              </span>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "100%" }}>
                      <span>Agent</span>
                    </td>
                    <td>
                      <input type="date" 
                          value={clause?.agent1_signature_date}
                          onChange={(e)=>setClause({...clause,agent1_signature_date:e.target.value})}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <span>
                <input
                  type="text"
                  value={clause?.agent2_signature}
                  onChange={(e)=>setClause({...clause,agent2_signature:e.target.value})}
                  style={{
                    outline: "none",
                    border: "none",
                    borderBottom: "1px solid black",
                    width: "99%"
                  }}
                />
              </span>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "100%" }}>
                      <span> Agent</span>
                    </td>
                    <td>
                      <input type="date" 
                          value={clause?.agent2_signature_date}
                          onChange={(e)=>setClause({...clause,agent2_signature_date:e.target.value})}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
  <tr>
    <td style={{ paddingTop: 10 }}>
      <span>
        Other provisions: Earnest deposit to be delivered within (5) business
        days.
      </span>
    </td>
  </tr>
</tbody>
</table>
<React.Fragment>
<div className="d-flex align-items-center justify-content-end mb-2 mr-2">
    <button onClick={send} className="btn primaryColorBtn">Submit 
    {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
    </button>
    <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
    <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button> 
</div>
          </React.Fragment>

<Esign
      canvasmodal={canvasmodal}
      setCanvasModal={setCanvasModal}
      htmlContent={htmlContent}
      setHtmlContent={setHtmlContent}
      selecteddocumentesign={selecteddocumentesign}
      setselectedDocumentEsign={setselectedDocumentEsign}
      type={"seller"}
    ></Esign>

      </>
    )
}
export default ALAaddendumtopurchase
